import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineInput } from "@air/component-inline-input";
import classNames from "classnames";
import { memo, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EditableMultilineTextTriggerButton } from "~/_components/InlineInput/EditableMultilineTextTriggerButton";
import { centralizedClipAssetIdSelector, centralizedClipDescriptionSelector, centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
import { useUpdateAssetDescription } from "~/swr-hooks/clips/useUpdateAssetDescription";
export const EditableInfoPanelDescription = /*#__PURE__*/ memo(()=>{
    const description = useSelector(centralizedClipDescriptionSelector);
    const clipId = useSelector(centralizedClipIdSelector);
    const assetId = useSelector(centralizedClipAssetIdSelector);
    const { updateAssetDescription } = useUpdateAssetDescription();
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(description);
    useEffect(()=>{
        setValue(description);
    }, [
        description
    ]);
    const onSubmit = useCallback((newDescription)=>{
        if (description !== newDescription) {
            updateAssetDescription(clipId, newDescription, assetId);
        }
    }, [
        assetId,
        clipId,
        description,
        updateAssetDescription
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex w-full shrink-0",
        children: [
            /*#__PURE__*/ _jsx(EditableMultilineTextTriggerButton, {
                placeholder: "Add description",
                className: classNames("h-full min-h-[32px] w-full px-2.5 py-1.5 text-12", isEditing ? "invisible" : "visible"),
                onClick: ()=>setIsEditing(true),
                value: value,
                appearance: "outline",
                color: "grey"
            }),
            isEditing && /*#__PURE__*/ _jsx("div", {
                className: "absolute inset-0 ml-px pt-px",
                children: /*#__PURE__*/ _jsx(InlineInput, {
                    label: "Asset description",
                    onSubmit: (value)=>{
                        setIsEditing(false);
                        onSubmit(value);
                    },
                    onCancel: ()=>{
                        setValue(description);
                        setIsEditing(false);
                    },
                    onChange: setValue,
                    className: "h-full",
                    inputClassName: "font-normal h-full text-12 md:text-12 overflow-hidden py-1 text-grey-11",
                    defaultValue: value,
                    placeholder: "Enter a description"
                })
            })
        ]
    });
});
EditableInfoPanelDescription.displayName = "EditableInfoPanelDescription";
